//Import OwlCarousel

import AOS from 'aos';
import {header_template, internal_header_template} from './ajax_templates/header_templates';
import {blocchi_home_templates} from './ajax_templates/blocchi_home_templates';
import {blocchi_pre_mappa_templates} from './ajax_templates/blocchi_pre_mappa_templates';
import {loadAnimalCategories} from './ajax_templates/categories_templates';
import {load_activities} from './ajax_templates/activities_template';
import {blocchi_valori_templates} from './ajax_templates/blocchi_valori_template';

//Import external functions
import { AjaxLoadMore } from './ajax-loadMore';

(function($) {
    $(document).ready(function(){

        new header_template();
        new internal_header_template();
        new blocchi_home_templates();
        new blocchi_pre_mappa_templates();
        new load_activities();

        new blocchi_valori_templates();
        new loadAnimalCategories();

        $(window).resize(function() {
            new header_template();
            new internal_header_template();
            new blocchi_home_templates();
            new blocchi_pre_mappa_templates();
            new blocchi_valori_templates();
        });

        AOS.init();
        //Function for Ajax Load More Listing items
        //new AjaxLoadMore();

        $(window).on('load', function() {
            setTimeout(function() {
                $('#sun-container').addClass('animated');
            }, 500); // Ritardo di 500ms
        });


        $(window).scroll(function () {
            if ($(this).scrollTop() > 50) { // Cambia "50" per regolare la soglia dello scroll
                $("#home_header_el").addClass("scrolled");
            } else {
                $("#home_header_el").removeClass("scrolled");
            }
        });

        if($('#animals_carousel')){
            $('#animals_carousel').owlCarousel({
                //items: 3,           // Mostra 3 slide contemporaneamente
                loop: true,         // Loop infinito
                margin: 16,         // Spazio tra le slide
                nav: true,          // Frecce di navigazione
                dots: false,        // Disabilita i dots sotto
                onInitialized: updateActive, // Quando il carousel si inizializza
                onTranslated: updateActive,   // Dopo ogni scorrimento
                responsive:{
                    0:{
                        items:1,
                        stagePadding:50,
                    },
                    600:{
                        items:2
                    },
                    1000:{
                        items:4,
                    }
                }
            })
            function updateActive(event) {
                $(".owl-item .item").removeClass("active_animal");

                // Trova il primo elemento visibile
                var firstVisibleItem = $(".owl-item.active").first().find(".item");
            
                // Aggiunge la classe 'active_animal' solo al primo elemento visibile
                firstVisibleItem.addClass("active_animal");
            
                // Ottieni il valore di data-id
                var activeId = firstVisibleItem.data("id");

                // Effettua una chiamata AJAX per ricaricare il template
                $.ajax({
                    url: ajax_object.ajax_url,  // Variabile fornita da WordPress
                    type: 'POST',
                    data: {
                        action: 'load_animal_details', // Nome della funzione PHP che gestisce la richiesta
                        animal_id: activeId // Passiamo l'ID del post animale
                    },
                    success: function(response) {
                        $("#animal_info_container").html(response); // Aggiorna il contenitore con i nuovi dati
                    },
                    error: function(error) {
                        console.log("Errore AJAX:", error);
                    }
                });
        
                // Stampa il valore in console
                console.log("Slide attiva:", activeId);
            }
        }


        //Carousel blocchi home
        // if($('#home_first_carousel')){
        //     $('#home_first_carousel').owlCarousel({
        //         loop:false,
        //         margin:0,
        //         nav:true,
        //         responsive:{
        //             0:{
        //                 items:1,
        //             },
        //             600:{
        //                 items:3
        //             },
        //             1000:{
        //                 items:3,
        //             }
        //         }
        //     })
        // }

        //Carousel blocchi pre mappa in INFO
        // if($('#pre_map_carousel')){
        //     $('#pre_map_carousel').owlCarousel({
        //         loop:false,
        //         margin:0,
        //         nav:true,
        //         responsive:{
        //             0:{
        //                 items:1,
        //             },
        //             600:{
        //                 items:3
        //             },
        //             1000:{
        //                 items:3,
        //             }
        //         }
        //     })
        // }

        //Carousel Gallery1
        if($('#gallery_one')){
            $('#gallery_one').owlCarousel({
                margin:16,
                loop:true,
                autoWidth:true,
                dots:false,
                //stagePadding: 50,
                responsive:{
                    0:{
                        items:1,
                    },
                    600:{
                        items:3
                    },
                    1000:{
                        items:4,
                    }
                }
            })
        }
        //Carousel Gallery2
        if($('#gallery_two')){
            $('#gallery_two').owlCarousel({
                margin:16,
                loop:true,
                autoWidth:true,
                dots:false,
                //stagePadding: 50,
                responsive:{
                    0:{
                        items:1,
                    },
                    600:{
                        items:3
                    },
                    1000:{
                        items:4,
                    }
                }
            })
        }

        //Carousel Recensioni
        if($('#recensioni_carousel')){
            var $carousel = $("#recensioni_carousel");

            function updatePrevCenter() {
                // Rimuovi le classi esistenti
                $carousel.find(".owl-item").removeClass("prev-center center_item");
        
                // Trova il nuovo elemento centrale e il precedente
                var $centerItem = $carousel.find(".owl-item.active.center");
                var $prevItem = $centerItem.prevAll(".owl-item.active").first();
        
                if ($centerItem.length) {
                    $centerItem.addClass("center_item");
                }
        
                if ($prevItem.length) {
                    $prevItem.addClass("prev-center");
                }
            }
        
            function predictNextClasses(event) {
                // Trova l'indice del prossimo elemento centrale PRIMA che il carousel si muova
                var itemIndex = event.item.index;
                var $allItems = $carousel.find(".owl-item");
        
                // Rimuovi le classi esistenti
                $allItems.removeClass("prev-center center_item");
        
                // Simula il prossimo centro
                var $nextCenterItem = $allItems.eq(itemIndex);
                var $nextPrevItem = $nextCenterItem.prevAll(".owl-item").first();
        
                if ($nextCenterItem.length) {
                    $nextCenterItem.addClass("center_item");
                }
        
                if ($nextPrevItem.length) {
                    $nextPrevItem.addClass("prev-center");
                }
            }
        
            // Inizializza il carousel
            $carousel.owlCarousel({
                items: 5,
                loop: true,
                center: true,
                margin: 25,
                nav: false,
                dots: true,
                onInitialized: updatePrevCenter,
                onTranslate: predictNextClasses, // Prevede le classi PRIMA che il carousel cambi
                onTranslated: updatePrevCenter,   // Corregge eventuali errori DOPO la transizione
                responsive:{
                    0:{
                        items:1,
                        loop:false,
                    },
                    600:{
                        items:3
                    },
                    1000:{
                        items:5,
                    }
                }
            });
        }
    });
})(jQuery);